import { useQuery } from "react-query";
import { fetchContactsAPI } from "../apis";

export const useContacts = (
  searchQuery: string,
  page: number,
  perPage: number,
  enabled: boolean // Control when the query should run
) => {
  return useQuery({
    // queryKey is an array that uniquely identifies this query.
    // When any value in this key changes, react-query will refetch the data.
    queryKey: ["contacts", searchQuery, page, perPage],

    // queryFn is the function that will be called to fetch the data.
    queryFn: () => fetchContactsAPI(searchQuery, page, perPage),

    // This is a great UX feature for pagination. It keeps showing the previous
    // page's data while the new page's data is being fetched in the background.
    keepPreviousData: true,

    // staleTime: 5 * 60 * 1000, // Optional: Cache data for 5 minutes

    // The query will only run if 'enabled' is true.
    enabled: enabled,
  });
};